<template>
  <div :class="['svgIcon',size]" :title="title" v-html="html"></div>
</template>

<script>
export default {
  name: 'SVGIcon',
  props: ['name', 'size'],
  computed: {
    html () {
      return require(`@/../public/img/vue_svg/${this.name}.svg`)
    },
    title () {
      return this.html.substring(
        this.html.lastIndexOf('<title>') + 7,
        this.html.lastIndexOf('</title>')
      )
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.small {
  width: 20px;
  height: 20px;
}
.big {
  width: 50px;
  height: 50px;
}
.little {
  width: 25px;
  height: 25px;
}
</style>
